import { useTranslation } from "react-i18next";

import { CardContainer } from "@/components/card-container";

import { useGetInfinitePayments } from "../../hooks/use-get-infinite-payment";
import { usePaymentFilters } from "../../hooks/use-payment-filters";

import { PaymentFilters } from "./components/payment-filters";
import { PaymentListComponent } from "./components/payment-list";

export const PaymentsPage = () => {
  const { t } = useTranslation();

  const { status, types } = usePaymentFilters();

  const {
    payments,
    getNextPageOfPayments,
    hasPaymentsErrored,
    isPaymentsLoading,
    hasPaymentNextPage,
  } = useGetInfinitePayments({ status, types });

  return (
    <CardContainer>
      <CardContainer.Header headerContentClassName="flex-col items-start gap-y-3 md:flex-row md:items-center md:gap-y-0">
        <CardContainer.HeaderContent>
          <CardContainer.CardTitle>{t("payments")}</CardContainer.CardTitle>
          <CardContainer.CardDescription>
            {t("payments_pageDescription")}
          </CardContainer.CardDescription>
        </CardContainer.HeaderContent>
        <CardContainer.TopRightContent>
          <PaymentFilters />
        </CardContainer.TopRightContent>
      </CardContainer.Header>
      <PaymentListComponent
        payments={payments}
        isLoading={isPaymentsLoading}
        isErrored={hasPaymentsErrored}
        hasNextPage={hasPaymentNextPage}
        onFetchMorePayments={getNextPageOfPayments}
      />
    </CardContainer>
  );
};
